import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../utils/constants';

const WAButton = () => {
  return (
    <motion.a
      href={WHATSAPP_LINK()}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-50 w-11 h-11 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-green-500/20 cursor-pointer"
    >
      <MessageCircle size={20} color="white" />
    </motion.a>
  );
};

export default WAButton;
